import { ConnectwareError, ConnectwareErrorType } from '../../../domain'

import type { HttpResponse } from '../Base'

export const isVersionOutdated = (latestVersion: string, currentVersion: string): boolean => {
    return latestVersion.localeCompare(currentVersion, undefined, { numeric: true }) === 1
}

const licenseErrorPatterns = { unableToRefresh: /^Unable to refresh license: .*$/gm, unableToUpdate: /^Unable to update license file: .*$/gm }

export const mapLicenseRequestError = async (
    response: Pick<HttpResponse<number, unknown>, 'getJson'>,
    errorPattern: keyof typeof licenseErrorPatterns
): Promise<ConnectwareError | undefined> => {
    const data = await response.getJson()

    if (data && typeof data === 'object' && 'message' in data && typeof data.message === 'string' && licenseErrorPatterns[errorPattern].test(data.message)) {
        /**
         * There was an issue with the license itself
         *
         * Either it is still expired or not active
         *
         * Can not be of type ConnectwareErrorType.CONFIGURATION_ERROR,
         * because it will be ignored then by https://bitbucket.org/cybusio/cybus/src/eb7e2227a7d679659cb6d6f3aa01d1e0b4631bc7/admin-web-app/src/application/usecases/License/Reload.ts
         */
        return new ConnectwareError(ConnectwareErrorType.BAD_REQUEST, data.message)
    }

    return undefined
}
